export default __webpack_public_path__ + "static/doing-work-f55164982a1d05f297fee9dbc287092a.svg";